(function ($, Drupal, once) {
  Drupal.behaviors.menuLanguageSwitcher = {
    attach: function (context, settings) {
      // Handle both block templates: block--system-menu-block--language and links--language-block
      $(once('d-languageswitcher', "#block-droopler-subtheme-language, #block-language", context)).each(function () {
        
        const $languageBlock = $(this);
        
        // Disable Bootstrap auto-initialization for this specific dropdown
        $languageBlock.find('.dropdown-toggle').removeAttr('data-toggle');
        
        // Mark as custom handled to prevent interference from other scripts
        $languageBlock.attr('data-custom-dropdown', 'true');
        const $dropdownToggle = $languageBlock.find('.dropdown-toggle');
        const $dropdownMenu = $languageBlock.find('.dropdown-menu');
        const desktopBreakpoint = 992;
        const isDesktopView = () => {
          return $(window).width() >= desktopBreakpoint;
        };
        const resetMobileState = () => {
          $dropdownMenu.removeClass('show').removeAttr('style');
          $dropdownToggle
            .css('display', '')
            .attr('aria-expanded', 'false')
            .removeAttr('aria-haspopup role tabindex');
        };
        const closeDropdown = () => {
          if (!isDesktopView()) {
            resetMobileState();
            return;
          }

          $dropdownMenu
            .removeClass('show')
            .attr('style', 'display: none !important;');
          $dropdownToggle.attr('aria-expanded', 'false');
        };
        const openDropdown = () => {
          if (!isDesktopView()) {
            resetMobileState();
            return;
          }

          $(document).trigger('d-menu:close');
          $dropdownMenu
            .addClass('show')
            .attr('style', 'display: block !important;');
          $dropdownToggle.attr('aria-expanded', 'true');
        };
        const isDropdownOpen = () => {
          return isDesktopView() && $dropdownToggle.attr('aria-expanded') === 'true' && $dropdownMenu.hasClass('show');
        };
        const closeOtherDropdowns = () => {
          $('.menu--language .dropdown-menu').not($dropdownMenu)
            .removeClass('show')
            .attr('style', 'display: none !important;');
          $('.menu--language .dropdown-toggle').not($dropdownToggle).attr('aria-expanded', 'false');
        };
        const initializeDesktopState = () => {
          $dropdownToggle.attr({
            'aria-expanded': 'false',
            'aria-haspopup': 'true',
            'role': 'button',
            'tabindex': '0'
          });
          closeDropdown();
        };

        if (isDesktopView()) {
          initializeDesktopState();
        }
        else {
          resetMobileState();
        }
        
        // Set active language code
        const activeLanguageCode = document.documentElement.lang;
        const activeLanguageLabel = $languageBlock.find('.active-lang-code')[0];
        if (activeLanguageLabel) {
          activeLanguageLabel.innerHTML = activeLanguageCode.toUpperCase();
        }

        // Handle dropdown toggle click
        $dropdownToggle.on('click', function(event) {
          if (!isDesktopView()) {
            resetMobileState();
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          
          const isOpen = isDropdownOpen();
          
          // Close all other language dropdowns first (only language switchers, not all dropdowns)
          closeOtherDropdowns();
          
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });

        // Close dropdown when clicking outside (with specific namespace to avoid conflicts)
        $(document).on('click.customLanguageDropdown', function(event) {
          // Only close on actual clicks, not other events
          // Check if this is our custom dropdown and if click is outside
          if (event.type === 'click' && 
              $languageBlock.attr('data-custom-dropdown') === 'true' &&
              !$(event.target).closest($languageBlock).length &&
              isDropdownOpen()) {
            closeDropdown();
          }
        });

        // Close dropdown on Escape key (with specific namespace)
        $(document).on('keydown.customLanguageDropdown', function(event) {
          if (event.key === 'Escape' && 
              $languageBlock.attr('data-custom-dropdown') === 'true' &&
              isDropdownOpen()) {
            closeDropdown();
            $dropdownToggle.focus();
          }
        });

        // Handle keyboard navigation
        $dropdownToggle.on('keydown', function(event) {
          if (!isDesktopView()) {
            resetMobileState();
            return;
          }

          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            $dropdownToggle.click();
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            openDropdown();
            $dropdownMenu.find('a').first().focus();
          }
        });

        // Handle navigation within dropdown
        $dropdownMenu.on('keydown', 'a', function(event) {
          const $links = $dropdownMenu.find('a');
          const currentIndex = $links.index(this);
          
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            const nextIndex = (currentIndex + 1) % $links.length;
            $links.eq(nextIndex).focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            const prevIndex = currentIndex === 0 ? $links.length - 1 : currentIndex - 1;
            $links.eq(prevIndex).focus();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            closeDropdown();
            $dropdownToggle.focus();
          }
        });

        $(document).on('d-language-switcher:close', closeDropdown);
        $(window).on('resize.customLanguageDropdown', function() {
          if (isDesktopView()) {
            initializeDesktopState();
          }
          else {
            resetMobileState();
          }
        });

        // Disable only hover events that could trigger dropdown opening
        // But allow clicks and normal link interactions
        $languageBlock.on('mouseenter mouseover', function(event) {
          // Only prevent if not clicking
          if (event.type === 'mouseenter' || event.type === 'mouseover') {
            event.stopPropagation();
          }
        });

        // Prevent dropdown from closing when moving mouse within dropdown area
        $dropdownMenu.on('mouseenter mouseleave', function(event) {
          event.stopPropagation();
        });

        // Keep dropdown open when hovering over links inside
        $dropdownMenu.on('mouseenter', 'a', function(event) {
          event.stopPropagation();
          // Ensure dropdown stays visible
          if (isDropdownOpen()) {
            $dropdownMenu.attr('style', 'display: block !important;');
          }
        });

        // Handle clicks on language links - allow normal navigation
        $dropdownMenu.on('click', 'a', function(event) {
          // Don't prevent default - allow normal link navigation
          // The page will reload with new language, so no need to close dropdown manually
          event.stopPropagation(); // Prevent document click handler from firing
        });
      });
    }
  };
})(jQuery, Drupal, once);
